"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReactConfirmAlert = void 0;
exports.default = confirmAlert;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/typeof"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _reactDom = require("react-dom");

var _material = require("@mui/material");

var _reactI18next = require("react-i18next");

var _styles = require("@mui/material/styles");

var _styles2 = require("@mui/styles");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _defaultTheme = _interopRequireDefault(require("../../shared/themes/defaultTheme"));

var _Modal = _interopRequireDefault(require("../Modal"));

var _templateObject;

var Message = _styledComponents.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  color: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.palette.secondary.main;
});

var ReactConfirmAlert = function ReactConfirmAlert(_ref2) {
  var title = _ref2.title,
      message = _ref2.message,
      buttons = _ref2.buttons,
      childrenElement = _ref2.childrenElement;

  function removeElementReconfirm() {
    var target = document.getElementById('sacd-confirm-alert');

    if (target) {
      (0, _reactDom.unmountComponentAtNode)(target);
      target.parentNode.removeChild(target);
    }
  }

  var close = function close() {
    removeElementReconfirm();
  };

  var handleClickButton = function handleClickButton(button) {
    if (button.onClick) button.onClick();
    close();
  }; // const theme = useTheme();


  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  return /*#__PURE__*/_react.default.createElement(_styles2.StylesProvider, {
    injectFirst: true
  }, /*#__PURE__*/_react.default.createElement(_styledComponents.ThemeProvider, {
    theme: _defaultTheme.default
  }, /*#__PURE__*/_react.default.createElement(_styles.StyledEngineProvider, {
    injectFirst: true
  }, /*#__PURE__*/_react.default.createElement(_styles.ThemeProvider, {
    theme: _defaultTheme.default
  }, /*#__PURE__*/_react.default.createElement(_Modal.default, {
    title: title,
    open: true,
    actionButtons: buttons.map(function (button) {
      return /*#__PURE__*/_react.default.createElement(_material.Button, {
        key: Math.random(),
        variant: "outlined",
        onClick: function onClick() {
          return handleClickButton(button);
        }
      }, button.label);
    })
  }, message && typeof message === 'string' && /*#__PURE__*/_react.default.createElement(Message, null, message), message && (0, _typeof2.default)(message) === 'object' && message.message && /*#__PURE__*/_react.default.createElement(Message, null, message.message), message && (0, _typeof2.default)(message) === 'object' && !message.message && /*#__PURE__*/_react.default.createElement(Message, null, t('popup.unexpectedError')), childrenElement())))));
};

exports.ReactConfirmAlert = ReactConfirmAlert;
ReactConfirmAlert.defaultProps = {
  title: 'Erreur',
  message: 'Une erreur inconnue est survenue.',
  childrenElement: function childrenElement() {
    return null;
  }
};

function createElementReconfirm(properties) {
  // Mount the ReactConfirmAlert component
  var divTarget = document.createElement('div');
  divTarget.id = 'sacd-confirm-alert';
  document.body.appendChild(divTarget);
  (0, _reactDom.render)( /*#__PURE__*/_react.default.createElement(ReactConfirmAlert, properties), divTarget);
}

function confirmAlert(properties) {
  createElementReconfirm(properties);
}